// extracted by mini-css-extract-plugin
export var modalOverlay = "ModalFrame-module--modalOverlay--aFxlx";
export var modalFrame = "ModalFrame-module--modalFrame--SkLfr";
export var card = "ModalFrame-module--card--YbKxB";